import React from 'react';

import { IProps } from './types';
import './desktop-email-verify-request-style.scss';

import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

const DesktopEmailVerifyRequestPage = ({ userEmail, onClickVerifyLaterButton, onClickResendEmailButton }: IProps) => {
  return (
    <div id="desktop-email-verify-request-wrapper">
      <div className="email-verify-request-content-wrapper">
        <Typography variant="h6" component="h4">
          Email Verification
        </Typography>

        <div className="text-wrapper">
          <Typography cName="info-text" variant="body3" component="p">
            {`We sent an email to `}
            <Typography variant="subtitle2" component="span">
              {userEmail}
            </Typography>
          </Typography>

          <Typography cName="info-text" variant="body3" component="p">
            {`click on the link in that email to complete verification.\nPlease check your spam folder if not received.`}
          </Typography>
        </div>

        <div className="btn-wrapper">
          <Button size="medium" cName="verify-later-btn" variant="text" onClick={onClickVerifyLaterButton}>
            Verify later
          </Button>

          <Button size="large" cName="resend-email-btn" variant="contained" onClick={onClickResendEmailButton}>
            Resend Email
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DesktopEmailVerifyRequestPage;
